<template>
  <div class="settings-alarms">
    <h2>{{ $t('settings.alarms.title') }}</h2>

    <div v-if="!loading">
      <b-field horizontal v-for="alarm in alarmsModel" :key="alarm.parameter" :label="alarm.title">
        <b-checkbox v-model="alarm.value"></b-checkbox>
      </b-field>
      <edit-button :editOptions="['save']" @click="save">
        <template>
          <span class="text">{{ $t('button.save') }}</span>
        </template>
      </edit-button>
    </div>
    <loader v-else></loader>
  </div>
</template>

<script>
import EditButton from '@/components/EditButton'
import Loader from '@/components/Loader'
export default {
  components: {
    EditButton,
    Loader
  },
  props: ['alarms', 'loading'],
  data() {
    return {
      alarmsModel: null
    }
  },
  methods: {
    save() {
      const alarms = this.alarmsModel.map(({ value, parameter }) => ({
        value,
        parameter
      }))
      this.$emit('save', alarms)
    },
    setAlarms(newAlarms) {
      if (newAlarms) {
        newAlarms = newAlarms.alarms
        const alarms = newAlarms.map(({ value, parameter }) => ({
          value,
          parameter,
          title: this.$t(`settings.alarms.${parameter}`)
        }))
        this.alarmsModel = this.$lodash.sortBy(alarms, ['title'])
      }
    },
    cancel() {
      this.setAlarms(this.alarms)
    }
  },
  watch: {
    alarms: {
      deep: true,
      immediate: true,
      handler: 'setAlarms'
    }
  }
}
</script>

<style lang="scss">
.settings-alarms {
  margin-bottom: 3rem;
}
</style>
